import cn from 'classnames';

import Breadcrumbs from 'components/BaseHelpers/Breadcrumbs';
import Image from 'components/BaseHelpers/Image';
import PatternBackground from 'components/BaseHelpers/PatternBackground';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreHeroData } from '../../../types/components';

import styles from './CoreHero.module.scss';

export type CoreHeroProps = ComponentProps & CoreHeroData;

const CoreHero = (props: CoreHeroProps): JSX.Element => {
  const { header, heroImage, breadcrumbs } = props.fields;

  if (!header) {
    return <></>;
  }

  return (
    <div className={styles.main} data-component="CoreHero">
      {heroImage ? (
        <Image
          className={styles.image}
          {...heroImage}
          fill
          fetchPriority="high"
          data-component="hero-image"
        />
      ) : (
        <PatternBackground
          className={styles.pattern}
          size="medium"
          theme="dark"
          fetchPriority="high"
        />
      )}
      <div className={cn('container-12', styles.container)}>
        <Breadcrumbs className={styles.breadcrumbs} breadcrumbs={breadcrumbs} />
        <h1 className={cn('heading-h2', styles.heading)}>
          <Text field={header} />
        </h1>
      </div>
    </div>
  );
};

export default CoreHero;
